export enum ProductDashboardCardViewProps {
  CO = 'kgCO',
  SUBSCRIPT = '2',
  POST_SUBSCRIPT = 'e',
  EDIT_GOAL_LABEL = 'Edit',
  SET_GOAL_LABEL = 'Set goal',
  CARBON_EMISSION = 'CO\u2082e',
  KG_CARBON_EMISSION = 'kgCO\u2082e',
  CONSUMER_UNIT_ONE = 'kg',
  CONSUMER_UNIT_TWO = 'per Kg',
  PERCENTAGE = '%',
}
